<div *ngIf="showModal" class="modal fade" [id]="modalId" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="'modal-' + modalSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="searchModalLabel" l10nTranslate>{{ title }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <form [formGroup]="formGroup" *ngIf="formGroup">
            <div class="row gx-3 gy-3">
              <div *ngFor="let field of fields" [ngClass]="field.colSize || 'col-sm-6 col-md-4'">
                <div class="form-group">
                  <label [for]="field.name" class="form-label text-primary fw-bold" l10nTranslate>{{ field.label }}</label>

                  <!-- Text Input -->
                  <input
                    *ngIf="field.type === 'text' || field.type === 'number'"
                    [type]="field.type"
                    [id]="field.name"
                    [formControlName]="field.name"
                    class="form-control text-box single-line"
                    [attr.touppercase]="field.uppercase ? '' : null"
                    [placeholder]="field.placeholder | translate : locale.language" />

                  <!-- Select -->
                  <ng-select
                    *ngIf="field.type === 'select'"
                    [id]="field.name"
                    class="custom"
                    [items]="field.options"
                    role="listbox"
                    bindValue="value"
                    bindLabel="text"
                    [notFoundText]="'$general.txtNoResultsFound' | translateAsync"
                    [formControlName]="field.name"
                    [disabled]="isFieldDisabled(field)"
                    [placeholder]="field.placeholder | translate : locale.language">
                  </ng-select>

                  <!-- Date Picker -->
                  <input
                    *ngIf="field.type === 'date'"
                    type="text"
                    [id]="field.name"
                    class="form-control"
                    bsDatepicker
                    [bsConfig]="field.dateConfig || { containerClass: 'theme-custom' }"
                    [formControlName]="field.name"
                    [placeholder]="field.placeholder | translate : locale.language"
                    placement="top"
                    autocomplete="off" />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="reset()" l10nTranslate>
          {{ resetButtonText }}
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="search()" l10nTranslate>
          {{ searchButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- If not using modal, just show the content -->
<div *ngIf="!showModal">
  <div class="container-fluid">
    <form [formGroup]="formGroup" *ngIf="formGroup">
      <div class="row gx-3 gy-3">
        <div *ngFor="let field of fields" [ngClass]="field.colSize || 'col-sm-6 col-md-4'">
          <div class="form-group">
            <label [for]="field.name" class="form-label text-primary fw-bold" l10nTranslate>{{ field.label }}</label>

            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text' || field.type === 'number'"
              [type]="field.type"
              [id]="field.name"
              [formControlName]="field.name"
              class="form-control text-box single-line"
              [attr.touppercase]="field.uppercase ? '' : null"
              [placeholder]="field.placeholder | translate : locale.language" />

            <!-- Select -->
            <ng-select
              *ngIf="field.type === 'select'"
              [id]="field.name"
              class="custom"
              [items]="field.options"
              role="listbox"
              bindValue="value"
              bindLabel="text"
              [notFoundText]="'$general.txtNoResultsFound' | translateAsync"
              [formControlName]="field.name"
              [disabled]="isFieldDisabled(field)"
              [placeholder]="field.placeholder | translate : locale.language">
            </ng-select>

            <!-- Date Picker -->
            <input
              *ngIf="field.type === 'date'"
              type="text"
              [id]="field.name"
              class="form-control"
              bsDatepicker
              [bsConfig]="field.dateConfig || { containerClass: 'theme-custom' }"
              [formControlName]="field.name"
              [placeholder]="field.placeholder | translate : locale.language"
              placement="top"
              autocomplete="off" />
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-3">
    <button type="button" class="btn btn-secondary me-2" (click)="reset()" l10nTranslate>
      {{ resetButtonText }}
    </button>
    <button type="button" class="btn btn-primary" (click)="search()" l10nTranslate>
      {{ searchButtonText }}
    </button>
  </div>
</div>
